import { NgModule } from '@angular/core';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatFormFieldModule,
    MatDividerModule,
    MatBadgeModule,
    MAT_DATE_LOCALE,
    DateAdapter,
    MAT_DATE_FORMATS
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
// import { DragDropModule } from '@angular/cdk/drag-drop';
// import { ScrollDispatchModule, ScrollingModule } from '@angular/cdk/scrolling';
// import { MatFileUploadModule } from 'angular-material-fileupload';
// import { NgScrollbarModule } from 'ngx-scrollbar';
// import { AmazingTimePickerModule } from 'amazing-time-picker';
// import { CurrencyMaskModule } from "ng2-currency-mask";
// import { SelectAutocompleteModule } from 'mat-select-autocomplete';

@NgModule({
    imports: [
        // CurrencyMaskModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatStepperModule,
        MatFormFieldModule,
        MatDividerModule,
        MatDialogModule,
        // DragDropModule,
        // ScrollDispatchModule,
        // ScrollingModule,
        MatBadgeModule,
        // MatFileUploadModule,
        // NgScrollbarModule,
        // AmazingTimePickerModule,
        // SelectAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        // CurrencyMaskModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatStepperModule,
        MatFormFieldModule,
        MatDividerModule,
        MatDialogModule,
        // DragDropModule,
        // ScrollDispatchModule,
        // ScrollingModule,
        MatBadgeModule,
        // MatFileUploadModule,
        // NgScrollbarModule,
        // AmazingTimePickerModule,
        // SelectAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
    ],

    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ]
})
export class MaterialModule { }
